import React from "react"

import { Link, graphql } from "gatsby"

import Layout from "../App/Layout"
import Navbar from "../App/Navbar"
import PageBanner from "../Common/PageBanner"
import Footer from "../App/Footer"
import BlogDetailsContent from "../BlogContent/BlogDetailsContent"
import { getLowResolutionImageURL } from "gatsby-plugin-image"

export const query = graphql`
  query ($slug: String!) {
    currentBlog: strapiBlogs(slug: { eq: $slug }) {
      slug
      blog_title
      content
      blog_category {
        category
      }
    }
    allStrapiBlogs(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          blog_title
          content
          blog_category {
            category
          }
          blog_title_img {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          slug
          createdAt(formatString: "DD MMMM, YYYY")
          updatedAt(formatString: "DD MMMM, YYYY")
          user {
            name
            email
            tagline
          }
          id
        }
      }
    }
    categoryData: allStrapiBlogs {
      group(field: blog_category___category) {
        fieldValue
        totalCount
      }
    }

    poppularBlogs: allStrapiBlogs(filter: { isPopular: { eq: true } }) {
      edges {
        node {
          blog_title
          blog_title_img {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          createdAt(formatString: "DD, MMMM, YYYY")
          slug
        }
      }
    }
  }
`

const BlogDetailPage = ({ data }) => {
  const currentSlug = data?.currentBlog?.slug;
  const posts = data?.allStrapiBlogs?.edges.map(edge => edge.node) || [];
  const currentIndex = posts.findIndex(post => post.slug === currentSlug);
  
  const prevPost = currentIndex > 0 ? posts[currentIndex - 1] : null;
  const nextPost = currentIndex < posts.length - 1 ? posts[currentIndex + 1] : null;

  // Get blog_title from currentBlog, not from currentSlug
  const { blog_title } = data?.currentBlog || {};
  
  return (
    <Layout>
      <Navbar />
      <PageBanner
        pageTitle={blog_title}
        homePageText="Home"
        homePageUrl="/"
        activePageText={blog_title} // No need for template literals if it's just a variable
      />
      <BlogDetailsContent data={data} prevPost={prevPost} nextPost={nextPost} />
      <Footer />
    </Layout>
  )
}

export default BlogDetailPage
